import React, { useState, useMemo } from "react";
import { useServer } from "../../services/api-client/useServer";
import { useSnackbar } from "../../services/api-client/useSnackbar";
import JobCard from "../../components/DesignSystem/Output/JobCard";
import { DONE, JobCardData } from "../../DataModels/DataModels";
import {
	SortMenu,
	SortFunction,
	defaultSort
} from "../../components/DesignSystem/Menu/SortMenu";
import Spinner from "../../components/DesignSystem/Output/Spinner";

const ArchJobPage: React.FC = () => {
	const server = useServer();
	const { showSnack } = useSnackbar();
	const { jobs, isLoading, error } = server.getJobs();
	const [sortFunc, setSortFunc] = useState<SortFunction<JobCardData>>(
		() => defaultSort
	);

	const isDesktop = window.innerWidth >= 500;

	const handleSortChange = (option: any) => {
		// Using a function as Data requires a special setter function
		setSortFunc(() => option.func);
	};

	const archivedJobs = useMemo(() => {
		return jobs.filter((job: JobCardData) => job.state === DONE).sort(sortFunc);
	}, [jobs, sortFunc]);

	if (error) {
		console.log("Archive Job error:", error);
		showSnack("NotifyNetworkError", "light");
	}

	if (isLoading) {
		return (
			<div className="flex justify-center items-center">
				<Spinner size="w-8 h-8" />
			</div>
		);
	}

	return (
		<div className="mx-16">
			{/* Header */}
			<div className="flex items-center justify-between mb-4">
				<div className="flex items-center gap-2">
					<h2 className="text-primary font-medium text-lg">Archived Jobs</h2>
					{archivedJobs.length > 3 && (
						<span className="text-primary text-sm">
							- {archivedJobs.length}
						</span>
					)}
				</div>

				{/* Sort Dropdown */}
				{archivedJobs.length > 3 && (
					<SortMenu
						isTitle={isDesktop}
						badgeClass={`bg-primary-background text-primary px-4 py-2 rounded-full ${
							isDesktop
								? "border-primary-inactive hover:border-primary-active border"
								: ""
						}`}
						onClick={handleSortChange}
					/>
				)}
			</div>

			{archivedJobs.length === 0 ? (
				<p>No archived jobs found.</p>
			) : (
				<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-4">
					{archivedJobs.map((job, index) => (
						<JobCard key={index} data={job} isArchive={true} />
					))}
				</div>
			)}
		</div>
	);
};

export default ArchJobPage;
